export const getStartAndEndDate = (timeRange) => {
    const end = new Date();
    const start = new Date();
    switch (timeRange) {
        case '7days':
            start.setDate(end.getDate() - 7);
            break;
        case '30days':
            start.setDate(end.getDate() - 30);
            break;
        case '90days':
            start.setDate(end.getDate() - 90);
            break;
        case '6months':
            start.setMonth(end.getMonth() - 6);
            break;
        case '1year':
            start.setFullYear(end.getFullYear() - 1);
            break;
        default:
            start.setDate(end.getDate() - 30);
    }
    return {
        startDate: start.toISOString(),
        endDate: end.toISOString(),
    };
};
